import script from "./snackBar.vue?vue&type=script&setup=true&lang=js"
export * from "./snackBar.vue?vue&type=script&setup=true&lang=js"

import "./snackBar.vue?vue&type=style&index=0&id=04761212&scoped=true&lang=css"

import exportComponent from "/builds/partout-chez-nous/admin-ui/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-04761212"]])

export default __exports__